var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotaIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 127,
    viewBox: "0 0 118 127",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.59668 2.66658H24.9292L86.2606 79.9974V5.66648L117.593 0V126.996H89.9271L31.929 53.3316V126.996H0.59668V2.66658Z",
    fill: "#f2f2f2"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotaIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/nota-icon.cccc94df.svg";
export { ForwardRef as ReactComponent };